import { IEntity } from '../interfaces/entity';

export interface IUrlList{
  items: Url[];
  totalCount: number;
}

export class Url implements IEntity {
  id: number;
  uid: string;
  link: string;
  summary: string;
  dateAdded: string;
  labels: string;
}
